import { render } from "./NewCardItem.vue?vue&type=template&id=19a683bc&scoped=true"
import script from "./NewCardItem.vue?vue&type=script&lang=js"
export * from "./NewCardItem.vue?vue&type=script&lang=js"

import "./NewCardItem.vue?vue&type=style&index=0&id=19a683bc&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a683bc"]])

export default __exports__